import { render, staticRenderFns } from "./FormKnowledge.vue?vue&type=template&id=a4bc113a&"
import script from "./FormKnowledge.vue?vue&type=script&lang=js&"
export * from "./FormKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports